export default __webpack_public_path__ + "media/Crowd_right.4a28e9e101b7a055c402a9ee9f26c6ef.svg";